import useBirlExerciseEntryCollectionQuery from 'generated/api/birl/exercise_entries/useBirlExerciseEntryCollectionQuery'
import Spinning from 'app/components/Spinning'
import { format } from 'date-fns'

const ColItem = ({ entry, index, birlExerciseEntries, noMatches }) => {
  return (
    <div
      className={clsx('fcol gray-transparent-box px-d pt-1', {
        'rounded-top': index == 0,
        'rounded-bottom': index == birlExerciseEntries.length - 1
      })}
    >
      <div className="text-3xs text-gray-700">
        {format(entry.executedAt, 'E, MMM dd')}
      </div>
      <div className="text-sm">{noMatches ? entry.full : entry.reps}</div>
    </div>
  )
}

const RowItem = ({ entry, index, birlExerciseEntries, noMatches }) => {
  return (
    <div className="frow items-center">
      <div
        className={clsx(
          'darkest-gray-transparent-box text-xs px-d h-10 frow items-center justify-end w-40',
          {
            'rounded-top-left': index == 0,
            'rounded-bottom-left': index == birlExerciseEntries.length - 1
          }
        )}
      >
        {format(entry.executedAt, 'E, MMM dd')}
      </div>
      <div
        className={clsx('gray-transparent-box px-d h-10 flex-1', {
          'text-sm pt-1': noMatches,
          'rounded-top-right': index == 0,
          'rounded-bottom-right': index == birlExerciseEntries.length - 1
        })}
      >
        {noMatches ? entry.full : entry.reps}
      </div>
    </div>
  )
}

const InnerBirlExerciseEntriesIndex = ({ exerciseId, weightSignature }) => {
  const { isPending, data: { birlExerciseEntries, noMatches } = {} } =
    useBirlExerciseEntryCollectionQuery({
      query: {
        birl_exercise_id: exerciseId,
        weight_signature: weightSignature
      }
    })

  if (isPending) return <Spinning />

  return (
    <div className="mb-d">
      {birlExerciseEntries.map((entry, index) => {
        return (
          <ColItem
            key={entry.id}
            entry={entry}
            index={index}
            birlExerciseEntries={birlExerciseEntries}
            noMatches={noMatches}
          />
        )
      })}
    </div>
  )
}

const BirlExerciseEntriesIndex = ({ exerciseId, weightSignature }) => {
  if (!exerciseId || !weightSignature) return null

  return (
    <InnerBirlExerciseEntriesIndex
      exerciseId={exerciseId}
      weightSignature={weightSignature}
    />
  )
}

export default BirlExerciseEntriesIndex
